import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/jobFunctions/scheduleApplicationActions'
import { actions as jobNoteActions } from '../../../redux/modules/jobFunctions/jobNoteActions'
import ScheduleApplicationDatesView from '../../../components/ScheduleApplicationDatesView'
import ScheduleMachinesMenu from '../../../components/ScheduleMachineMenu'
import Loader from '../../common/Loader'
import Notes from '../../../components/notes/Notes'

const propTypes = {}

class ScheduleApplications extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditing: false,
      machineIndex: this.props.scheduleApplicationId,
      arrayIndex: 0
    }

    this.props.getScheduleApplicationDates({
      jobId: this.props.jobId
    })
    this.props.getScheduleNote({
      jobId: this.props.jobId
    })
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.scheduleApplicationActions.scheduleApplicationDates !==
      nextProps.scheduleApplicationActions.scheduleApplicationDates
    ) {
      this.setState({
        machineIndex:
          nextProps.scheduleApplicationActions.scheduleApplicationDates &&
          nextProps.scheduleApplicationActions.scheduleApplicationDates.data[
            nextProps.scheduleApplicationActions.scheduleApplicationDates.data.length - 1
          ].id,
        arrayIndex: nextProps.scheduleApplicationActions.scheduleApplicationDates.data.length - 1
      })
    }
  }

  handleEditDateClick = () => {
    this.setState({
      isEditing: true
    })
  }

  changeMachineIndex = (arrayIndex, index) => {
    this.setState({
      machineIndex: index,
      arrayIndex: arrayIndex
    })
  }

  handleDeleteSchedule = scheduleId => {
    this.props.deleteScheduleApplication({
      jobId: this.props.jobId,
      scheduleId: scheduleId
    })
    this.setState({
      machineIndex: 1,
      arrayIndex: 0
    })
  }

  clearFields = () => {
    this.setState({ contentData: null, currentId: 0, isEditing: false })
  }

  // notes things
  handleToggleNoteEditArea = () => {
    if (this.state.currentNote) {
      this.setState({
        currentNote: null,
        currentNoteId: null,
        noteAddEditContainer: true
      })
    } else {
      this.setState({
        noteAddEditContainer: !this.state.noteAddEditContainer
      })
    }
  }

  createNote = params => {
    this.props.createScheduleNote({
      content: params,
      userId: this.props.user.userId,
      jobId: this.props.jobId
    })

    this.handleToggleNoteEditArea()
  }

  updateNote = params => {
    this.props.editScheduleNote({
      content: params,
      noteId: this.state.currentNoteId,
      jobId: this.props.jobId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null
    })
  }

  deleteNote = () => {
    this.props.deleteScheduleNote({
      noteId: this.state.currentNoteId,
      jobId: this.props.jobId
    })

    this.handleToggleNoteEditArea()

    this.setState({
      currentNote: null,
      currentNoteId: null,
      noteAddEditContainer: false
    })
  }

  handleRowNoteClick = row => {
    this.setState({
      noteAddEditContainer: true,
      currentNote: row,
      currentNoteId: row.id
    })
  }

  render() {
    const { scheduleApplicationDates } = this.props.scheduleApplicationActions

    if (!scheduleApplicationDates) {
      return <Loader />
    }
    return (
      <div>
        <div className="jobsBar">
          Schedule Applications/Permits
          {!this.state.isEditing && (
            <div className="jobsBarAdd" onClick={() => this.handleEditDateClick()}>
              <i className="fa fa-pencil-square" aria-hidden="true" />
              &nbsp;<div className="addJobLabel">EDIT Dates</div>
            </div>
          )}
        </div>
        <ScheduleMachinesMenu
          data={scheduleApplicationDates.data}
          currentIndex={this.state.arrayIndex}
          changeMachineIndex={this.changeMachineIndex}
          addMachine={this.props.addScheduleApplicationDate}
          jobId={this.props.jobId}
          userId={this.props.user.userId}
        />
        <ScheduleApplicationDatesView
          data={scheduleApplicationDates.data[this.state.arrayIndex]}
          machineIndex={this.state.machineIndex}
          isEditing={this.state.isEditing}
          updateApplicationDates={this.props.updateApplicationDates}
          deleteSchedule={this.handleDeleteSchedule}
          updateNotes={this.props.updateNotes}
          jobId={this.props.jobId}
          clearFields={this.clearFields}
          clearHighlight={this.props.clearHighlight}
          scheduleApplicationType={this.props.scheduleApplicationType}
          userId={this.props.user.userId}
          jobNotes={
            this.props.jobNoteActions &&
            this.props.jobNoteActions.notes &&
            this.props.jobNoteActions.notes.data
          }
          createNote={this.props.createNote}
          updateNote={this.props.updateNote}
          deleteNote={this.props.deleteNote}
        />
        <div className="row p-5">
          <div className="col-12">
            <Notes
              // notes props
              currentNote={this.state.currentNote}
              currentNoteId={this.state.currentNoteId}
              notes={
                this.props.jobNoteActions.scheduleNotes &&
                this.props.jobNoteActions.scheduleNotes.data
              }
              handleToggleNoteEditArea={this.handleToggleNoteEditArea}
              noteAddEditContainer={this.state.noteAddEditContainer}
              createNote={this.createNote}
              handleRowNoteClick={this.handleRowNoteClick}
              updateNote={this.updateNote}
              userId={this.props.user.userId}
              deleteNote={this.deleteNote}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ scheduleApplicationActions, jobNoteActions }, ownProps) => ({
  scheduleApplicationActions,
  jobNoteActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions, jobNoteActions), dispatch)
})

ScheduleApplications.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ScheduleApplications))



// WEBPACK FOOTER //
// ./src/containers/job/tasks/ScheduleApplications.js